import styled, { css } from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { ResponsiveContainer } from 'recharts';
import { ComponentProps } from './types';

const Wrapper = styled(ResponsiveContainer)<ComponentProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.white};

  .recharts-surface {
    padding: 2rem 0rem 1rem 1rem;
  }

  .recharts-cartesian-axis-line {
    stroke: ${({ theme }) => theme.colors.gray2};
  }

  .recharts-text {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
    font-size: 1.0625rem;
    line-height: 1.5rem;
  }

  .recharts-cartesian-axis-tick-line {
    display: none;
  }

  .recharts-reference-line {
    stroke-dasharray: 10 10;
  }

  .recharts-reference-line text {
    font-size: 1.0625rem;
    line-height: 1.5rem;
    font-weight: 600;
    text-align: right;
  }

  .recharts-reference-line line {
    stroke-width: 0.125rem;
  }

  circle {
    visibility: hidden;
    :first-child,
    :last-child {
      visibility: visible;
      r: 0.45rem;
      fill-opacity: 1;
      stroke-width: 2;
      stroke: ${({ theme }) => theme.colors.white};
    }
  }

  .recharts-layer path {
    stroke-width: 0.25rem;
  }

  ${({ $variant }) => {
    switch ($variant) {
      case 'green':
        return css`
          .recharts-reference-line line {
            stroke: ${({ theme }) => theme.colors.greenDark};
          }
          circle {
            :first-child,
            :last-child {
              fill: ${({ theme }) => theme.colors.greenMedium};
            }
          }
          .recharts-layer path {
            :last-child {
              stroke: ${({ theme }) => theme.colors.greenMedium};
            }
            :first-child {
              fill: ${({ theme }) => theme.colors.greenExtraLight};
            }
          }
        `;
      case 'red':
        return css`
          .recharts-reference-line line {
            stroke: ${({ theme }) => theme.colors.redDark};
          }
          circle {
            :first-child,
            :last-child {
              fill: ${({ theme }) => theme.colors.redMedium};
            }
          }
          .recharts-layer path {
            :last-child {
              stroke: ${({ theme }) => theme.colors.redMedium};
            }
            :first-child {
              fill: ${({ theme }) => theme.colors.redExtraLight};
            }
          }
        `;
      case 'yellow':
      default:
        return css`
        .recharts-reference-line line {
          stroke: ${({ theme }) => theme.colors.yellowDark};
        }
        circle {
          :first-child,
          :last-child {
            fill: ${({ theme }) => theme.colors.yellowMedium};
          }
        }
        .recharts-layer path {
          :last-child {
            stroke: ${({ theme }) => theme.colors.yellowMedium};
          }
          :first-child {
            fill: ${({ theme }) => theme.colors.yellowLight};
          }
        }
        }
        `;
    }
  }}
`;

export default Wrapper;
